import { render, staticRenderFns } from "./CommonTable.vue?vue&type=template&id=03edd37c&scoped=true&"
import script from "./CommonTable.vue?vue&type=script&lang=js&"
export * from "./CommonTable.vue?vue&type=script&lang=js&"
import style0 from "./CommonTable.vue?vue&type=style&index=0&id=03edd37c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03edd37c",
  null
  
)

export default component.exports